import { Icon } from '../../shared/Icon';
import type { User } from '../../types/api';
import { navigationFor, type ViewName } from './navigation';

interface Props {
  activeView: ViewName;
  user: User;
  onNavigate: (view: ViewName) => void;
  onLogout: () => void;
}

function initials(name: string) {
  return name.split(/\s+/).slice(0, 2).map(part => part[0]).join('').toUpperCase();
}

export function Sidebar({ activeView, user, onNavigate, onLogout }: Props) {
  const items = navigationFor(user.features);
  return <aside className="sidebar" aria-label="Hovedmeny">
    <button className="brand brand-button" onClick={() => onNavigate('today')} aria-label="Mellomrom hjem">
      <span className="brand-mark">M</span><span>Mellomrom</span>
    </button>
    <nav className="side-nav">
      {items.map(item => <button key={item.view} className={`nav-item ${activeView === item.view ? 'active' : ''}`} onClick={() => onNavigate(item.view)}>
        <Icon name={item.icon} /><span>{item.label}</span>
      </button>)}
    </nav>
    <div className="sidebar-bottom">
      <div className="level-card">
        <div className="level-row"><span>Nivåprofil</span><strong>{user.level}</strong></div>
        <p>Selvvalgt nivå · ikke en automatisk CEFR-score</p>
      </div>
      <button className="profile-button" onClick={onLogout} aria-label="Logg ut">
        <span className="avatar">{initials(user.displayName)}</span>
        <span><strong>{user.displayName}</strong><small>Logg ut</small></span>
        <Icon name="menu" />
      </button>
    </div>
  </aside>;
}
